import { WidgetChoice } from '@/common/form/choice'
import dayjs from 'dayjs'

export const dateToDefaultInput = (dateStr: string | null): Date | null => {
  if (!dateStr) {
    return null
  }
  return new Date(dateStr)
}

export const timeToDefaultInput = (dateStr?: string): string | null => {
  if (!dateStr) {
    return null
  }
  return dayjs(dateStr).format('HH:mm:ss')
}

export const dateTimeToField = (date: Date | null | undefined): string | undefined => {
  if (!date) {
    return undefined
  }
  return dayjs(date).format('YYYY-MM-DD HH:mm')
}

export const dateToField = (date: Date | null | undefined): string | undefined => {
  if (!date) {
    return undefined
  }
  return dayjs(date).format('YYYY-MM-DD')
}

export const dateToRequest = (
  date: Date | string,
  options?: { lte?: boolean; lteMinute?: boolean }
): string => {
  return (
    options?.lte ? dayjs(date).endOf(options.lteMinute ? 'minute' : 'day') : dayjs(date)
  ).toISOString()
}

export const timeToRequest = (time: string): string | null => {
  const times = time.split(':')
  return times.length >= 2
    ? dayjs()
        .startOf('year')
        .set('hour', Number(times[0]))
        .set('minute', Number(times[1]))
        .toISOString()
    : null
}

// dateStr / dateTimeStr / timeStr の実体は common/util/date.ts（view 層から参照できるよう移設した）
export { dateStr, dateTimeStr, timeStr } from '@/common/util/date'

export const dateTimeDiff = (date1: Date | string, date2: Date | string) => {
  const day1 = dayjs(date1)
  const day2 = dayjs(date2)

  return (
    day1.diff(day2, 'hour').toString().padStart(2, '0') +
    ':' +
    (day1.diff(day2, 'minute') % 60).toString().padStart(2, '0') +
    ':' +
    (day1.diff(day2, 'second') % 60).toString().padStart(2, '0')
  )
}

export const dayChoices = (): WidgetChoice<number>[] => {
  return [...Array(31)].map((_, index) => ({
    name: String(index + 1) + '日',
    value: index + 1
  }))
}

export const hourChoices = (): WidgetChoice<number>[] => {
  return [...Array(24)].map((_, index) => ({
    name: String(index) + ':00',
    value: index
  }))
}

export const minuteChoices = (): WidgetChoice<number>[] => {
  return [...Array(60)].map((_, index) => ({
    name: String(index) + '分',
    value: index
  }))
}

export const weekdayJa = (date: Date | string): string => {
  const w = dayjs(date).day() // 0=日 ... 6=土
  return ['日', '月', '火', '水', '木', '金', '土'][w]
}

export const dateStrWithWeekday = (date: Date | string): string => {
  return `${dayjs(date).format('YYYY/MM/DD')}(${weekdayJa(date)})`
}
